import { toCurrencyString } from 'app/util/methods';

export const formatDetails = (details: string | number): string => {
  if (typeof details === 'string') return details;

  if (isNaN(details)) return 'Unable to calculate';

  return toCurrencyString(details);
};
